document
	.querySelectorAll<HTMLElement>('[data-product-overview]')
	.forEach(overview => {
		const buttons = overview.querySelectorAll<HTMLElement>(
			'[data-product-overview-dot]',
		);
		const textWrapper = overview.querySelector<HTMLDivElement>(
			'[data-product-overview-info',
		);

		const dot = document.createElement('span');
		dot.classList.add('product-overview__dot', 'product-overview__dot--inline');

		const text = document.createElement('span');

		const clearButtons = () => {
			buttons.forEach(button => {
				button.classList.remove('product-overview__dot--active');
			});
		};

		let clicked = false;

		const setButton = (button: HTMLElement, click = false) => {
			if (click) {
				clicked = true;
			}

			const description = button.getAttribute('data-product-overview-dot');
			if (!description) return;

			text.innerText = description;

			textWrapper?.appendChild(dot);
			textWrapper?.appendChild(text);

			buttons.forEach(b => {
				b.classList.toggle('product-overview__dot--active', b === button);
			});
		};

		if (buttons.length > 0) {
			setButton(buttons[0], true);
		}

		buttons.forEach(button => {
			button.addEventListener('click', () => {
				clearButtons();
				setButton(button, true);
				clicked = true;
			});

			button.addEventListener('mouseover', () => {
				if (!clicked) {
					setButton(button);
					/*text.innerText = title;
                    textWrapper?.appendChild(dot);
                    textWrapper?.appendChild(text);*/
				}
			});

			button.addEventListener('mouseout', () => {
				if (!clicked) {
					setButton(button);
					/*textWrapper?.removeChild(dot);
                     textWrapper?.removeChild(text);*/
				}
			});
		});
	});
